import React, { useContext, useEffect } from 'react'
import { VoidCallback } from 'types/index'

interface GridGroupContextValues {
	forceNoHorizScroll: VoidCallback
}
const defaultContext: GridGroupContextValues = {
	forceNoHorizScroll: () => {
		// do nothing
	}
}
export const GridGroupContext = React.createContext<GridGroupContextValues>(defaultContext)

export const useForceNoHScroll = (): void => {
	const { forceNoHorizScroll } = useContext(GridGroupContext)
	useEffect(() => {
		forceNoHorizScroll()
	})
}
